






























































































import {
  MONTH_OPTIONS,
  ONE,
  TOTAL_QUARTERS,
} from "@/models/constant/global.constant";
import { CashFlowPeriodType } from "@/models/interface/cash-flow-report/CashFlowReport.interface";
import { Component, Prop, Vue } from "vue-property-decorator";

interface FilterState {
  periodType: CashFlowPeriodType;
  year: number;
  month: number | undefined;
  quarterCount: number | undefined;
}

@Component
export default class CashFlowFilterForm extends Vue {
  @Prop({ default: false }) loading!: boolean;

  monthOptions = MONTH_OPTIONS;
  totalQuarters = TOTAL_QUARTERS;
  CashFlowPeriodType = CashFlowPeriodType;

  filterState: FilterState = {
    periodType: CashFlowPeriodType.MONTHLY,
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    quarterCount: ONE,
  };

  get showMonthSelect(): boolean {
    return this.filterState.periodType === CashFlowPeriodType.MONTHLY;
  }

  get showQuarterSelect(): boolean {
    return this.filterState.periodType === CashFlowPeriodType.QUARTERLY;
  }

  get yearOptions(): number[] {
    const current = new Date().getFullYear();
    return Array.from({ length: 10 }, (_, i) => current - i);
  }

  onPeriodTypeChange(type: CashFlowPeriodType): void {
    if (type !== CashFlowPeriodType.MONTHLY) {
      this.filterState.month = new Date().getMonth() + 1;
    }
    if (type !== CashFlowPeriodType.QUARTERLY) {
      this.filterState.quarterCount = ONE;
    }
    if (type === CashFlowPeriodType.MONTHLY) {
      this.filterState.month = new Date().getMonth() + 1;
    }
  }

  onFind(): void {
    this.$emit("submit", { ...this.filterState });
  }

  onReset(): void {
    this.filterState.periodType = CashFlowPeriodType.MONTHLY;
    this.filterState.year = new Date().getFullYear();
    this.filterState.month = new Date().getMonth() + 1;
    this.filterState.quarterCount = ONE;
  }
}
